module.exports = __webpack_public_path__ + "static/media/cart-item-image-bigger.de034d54.png";